import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ServerDownComponent } from "./server-down.component";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  declarations: [ServerDownComponent],
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule],
  exports: [ServerDownComponent],
})
export class ServerDownComponentModule {}
